import AbstractRequestTask from '../AbstractRequestTask';
import Launcher from '../../apa/Launcher';
import { isEnabledCenterNotificationsWithByUserType } from '../../../utils/Utils';

class PayWayProfileTask extends AbstractRequestTask {
    constructor(params) {
        super();
        this.params = params;

        this.isByUserType = isEnabledCenterNotificationsWithByUserType();
        this.version = this.isByUserType ? "v2" : "v1";
    }

    getMethod() {
        return 'GET';
    }

    getHeaders() {
        const params = super.getParams();
        return {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + params.user_token
        };
    }

    getParams() {
        const params = super.getParams();
        return {
          authpn: params.authpn,
          authpt: params.authpt,
      };
    }

    getUrl() {
        const http = 'https://';
        const url = Launcher.get('akamai_mfwk');
        return `${http}${url}/services/payway/paymentservice/${this.version}/profile`;
    }

    success(data, b) {
        this.resolve(data);
    }
}

export default PayWayProfileTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/payway/PayWayProfileTask.js